module.exports = __webpack_public_path__ + "static/media/bo.61147aeb.webp";